module.exports = __webpack_public_path__ + "img/2025big23.04272cbe.jpg";